module.exports = __webpack_public_path__ + "fepro/img/wait.98c20b72.png";